<div class="avatar" [matMenuTriggerFor]="menu" #menuTrigger (menuClosed)="(true)">
  {{ user.firstName[0] }}
</div>
<mat-menu #menu="matMenu">
  <div style="display: flex; flex-direction: row;" class="user-info">
    <div class="menu-avatar">
      {{ user.firstName[0] }}
    </div>

    <div class="name">
      <div class="name-line">{{ user.firstName }}</div>
      <div class="name-line">{{ user.lastName }}</div>
    </div>
  </div>
  <a mat-menu-item routerLink="/user/profile">
    <mat-icon>person</mat-icon>
    <span>My profile</span>
  </a>
  @if (isAdmin && !isInAdmin) {
    <a mat-menu-item routerLink="/admin">
      <mat-icon>apps</mat-icon>
      <span>Admin</span>
    </a>
  }
  @if (isAdmin && !isInAuditing) {
    <a mat-menu-item routerLink="/auditing">
      <mat-icon>visibility</mat-icon>
      <span>Auditing</span>
    </a>
  }
  @if (isAdmin && isInAdmin) {
    <a mat-menu-item routerLink="/audits">
      <mat-icon>apps</mat-icon>
      <span>Back to Reports</span>
    </a>
  }
  <button mat-menu-item (click)="onLogout()">
    <mat-icon>power_settings_new</mat-icon>
    <span>Log out</span>
  </button>
</mat-menu>
